import {log, logError} from '../webUtils'
import {registerMusic, deleteMusic, videoOperation, showImage} from '../actions/mediaActions'


const medias = (state = [], action) => {
  switch (action.type) {
    case 'REGISTER_MEDIA':
      var id= Math.max(0, ...state.map(f => f.id)) + 1;
      if(action.mediaType == 'MUSIC')
        action.asyncDispatch(registerMusic(action.groupId, id));
      return [
        ...state,
        {
          id: id,
          name: action.name,
          fileName:action.fileName,
          value: action.value,
          mediaType: action.mediaType,
          groupId: action.groupId,
          activityId: action.activityId,
          src: action.src,
        }
      ]
    case 'SET_MEDIA_LIST':
      return action.list;
      // Systeme a revoir!
    case 'PLAY_MEDIA':
      let media = state.find(({id}) => id == action.id)
      if(action.mode == 'DEFAULT')  // Deja géré par mediaPlayer
        return state;
      if(media) {
        switch(media.mediaType) {
          case 'VIDEO':
            action.asyncDispatch(videoOperation(media, action.operation, action.mode, action.options));
            break;
          // case 'IMAGE':
          //   action.asyncDispatch(showImage(media, action.mode));
          //   break;          
          // case 'AUDIO':
          //   action.asyncDispatch(showImage(media, action.mode));
          //   break;
          default:
            console.error(`Unrecognized media type`, media)
        }
      }
      else
        console.error(`Can't find refered media: `,action)
      return state;
    case 'CHANGE_MEDIA':
      return state.map(media => {
        if(media.id === action.id) {
          var newMedia = {...media};
          newMedia[action.targetName] = action.targetValue;
          return newMedia;
        }
        return media;
      })
    case 'DELETE_MEDIA':
      if(typeof action.meta === 'object' 
        && action.meta.context == 'SERVER') {
        var item = state.find(({ id }) => id == action.id);
        action.asyncDispatch(engineDeleteMedia(item));
      }
      // Playlist
      var item = state.find(({ id }) => id == action.id);
      if(typeof item === 'object' && item.mediaType == 'MUSIC')
        action.asyncDispatch(deleteMusic(item.groupId, item.id))

      return state.filter(({ id }) => id !== action.id);
    case 'PUSH_ACTIVITY_CONTENT':
      if(typeof action.data.medias == 'undefined') {
        log('Undefined data.enigmas from server.')
        return state;
      }
      else
        return action.data.medias;
    case 'SET_STATE_FROM_DATABASE':
      if(typeof action.state.medias === 'undefined') {
        log ('Undefined "state.medias" from server.')
        return state;
      }
      else
        return action.state.medias;
    default:
      return state
  }
}

export default medias
